// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1YCCA","text":"SelectPayment_text__2Cnvt","title":"SelectPayment_title__2NfVD","btn":"SelectPayment_btn__K7Zwr"};